<template>
  <v-sheet
    color=primary
    class="main--text white--text"
    >
    <v-container
      fluid>
      <v-row
        justify=center>
        <v-col
          cols=auto>
          <h1
            :class="messageClass">{{message}}</h1>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    barClass () {
      return (this.isMobile) ? 'section-bar-mobile' : 'section-bar'
    },
    messageClass() {
      return (this.isMobile) ? 'section-bar-message-mobile' : 'section-bar-message'
    }
  }

}
</script>

<style scoped>
.section-bar {
}

.section-bar-message {
  font-size: 3.0rem;
}

.section-bar-mobile {
}

.section-bar-message-mobile {
  font-size: 2.0rem;
}
</style>
